import { authService } from '../services/auth';

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

export const apiCall = async (url: string, options: RequestInit = {}): Promise<Response> => {
  const authHeaders = authService.getAuthHeaders();
  
  const response = await fetch(`${API_BASE_URL}${url}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...authHeaders,
      ...options.headers,
    },
  });

  // Handle authentication errors
  if (response.status === 401) {
    authService.logout();
    window.location.reload(); // Force re-login
  }

  return response;
};

export const uploadFile = async (url: string, file: File): Promise<Response> => {
  const authHeaders = authService.getAuthHeaders();
  const formData = new FormData();
  formData.append('file', file);

  const response = await fetch(`${API_BASE_URL}${url}`, {
    method: 'POST',
    body: formData,
    headers: {
      ...authHeaders,
    },
  });

  // Handle authentication errors
  if (response.status === 401) {
    authService.logout();
    window.location.reload(); // Force re-login
  }

  return response;
};